import {
  QuickBooksAccount as QuickBooksAccountProto,
  XeroAccount as XeroAccountProto,
  OtherPlatformConnection as OtherPlatformAccount,
} from '@taxfyle/api-internal/internal/bookkeeping_pb'
import { Model } from 'infra/model'
import { computed, makeObservable, observable } from 'mobx'
import { Id } from 'types/definitions'

export class QuickBooksAccount extends Model<
  QuickBooksAccountProto.AsObject,
  QuickBooksAccount
> {
  @observable
  connectionId = Id.none

  @observable
  realmId = ''

  @observable
  companyName = ''

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get displayId() {
    return this.realmId
  }

  @computed
  get displayName() {
    return this.companyName
  }

  @computed
  get helpText() {
    return 'Log into QuickBooks and give the Pro access to the client’s books. Then, click the "Confirm Access" button below to complete the connection.'
  }

  parse(attrs: QuickBooksAccountProto.AsObject): Partial<QuickBooksAccount> {
    return {
      realmId: attrs.realmId,
      companyName: attrs.companyName,
      connectionId: attrs.connectionId,
    }
  }
}

export class XeroAccount extends Model<XeroAccountProto.AsObject, XeroAccount> {
  @observable
  connectionId = Id.none

  @observable
  tenantId = ''

  @observable
  tenantName = ''

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get displayId() {
    return this.tenantId
  }

  @computed
  get displayName() {
    return this.tenantName
  }

  @computed
  get helpText() {
    return 'Log into Xero and give the Pro access to the client’s books. Then, click the "Confirm Access" button below to complete the connection.'
  }

  parse(attrs: XeroAccountProto.AsObject): Partial<XeroAccount> {
    return {
      tenantId: attrs.tenantId,
      tenantName: attrs.tenantName,
      connectionId: attrs.connectionId,
    }
  }
}

export class OtherAccount extends Model<
  OtherPlatformAccount.AsObject,
  OtherAccount
> {
  @observable
  info = ''

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get displayId() {
    return null
  }

  @computed
  get displayName() {
    return null
  }

  @computed
  get helpText() {
    return 'Based on the respective software, instruct the client to give the Pro access to their books. Then, click the "Confirm Access" button below to complete the connection.'
  }

  parse(attrs: OtherPlatformAccount.AsObject): Partial<OtherAccount> {
    return {
      info: attrs.info,
    }
  }
}

export type BookkeepingPlatformConnection =
  | QuickBooksAccount
  | XeroAccount
  | OtherAccount
